__turbopack_context__.v({
  "highlight": "fFDNsq_highlight",
  "keyfact-highlights": "fFDNsq_keyfact-highlights",
  "label": "fFDNsq_label",
});
